import {
  CREATE_USER_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_USER_FAILURE,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
} from "./usersTypes";
 
const initialStateForUser = {
  loading: false,
  users: [],
  error: "",
};

const UserReducer = (state = initialStateForUser, action) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_SUCCESS:
      return {
        loading: false,
        users: action.payload,
        error: "",
      };
    case GET_USER_FAILURE:
      return {
        loading: false,
        users: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCreateUser = {
  loading: false,
  create: {},
  error: "",
};

const createUserReducer = (state = initialStateForCreateUser, action) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_USER_SUCCESS:
      return {
        loading: true,
        create: action.payload,
        error: "",
      };
    case CREATE_USER_FAILURE:
      return {
        loading: false,
        create: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForEdit = {
  loading: false,
  edit: {},
  error: "",
};

const editUserReducer = (state = initialStateForEdit, action) => {
  switch (action.type) {
    case EDIT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_USER_SUCCESS:
      return {
        loading: true,
        edit: action.payload,
        error: "",
      };
    case EDIT_USER_FAILURE:
      return {
        loading: false,
        edit: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDelete = {
  loading: false,
  deleteUser: {},
  error: "",
};

const deleteUserReducer = (state = initialStateForDelete, action) => {
  switch (action.type) {
    case DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_USER_SUCCESS:
      return {
        loading: false,
        deleteUser: action.payload,
        error: "",
      };
    case DELETE_USER_FAILURE:
      return {
        loading: false,
        deleteUser: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export { UserReducer, createUserReducer, editUserReducer, deleteUserReducer };
